import Swiper, { EffectCreative, Pagination } from 'swiper'

Swiper.use([EffectCreative, Pagination])

export default function StoriesSlider () {
  const STORIES_SLIDER_WRAPPERS = document.querySelectorAll('.mtt-stories-slider')
  const AUDIO = new Audio()

  if (STORIES_SLIDER_WRAPPERS.length) {
    for (let i = 0; i < STORIES_SLIDER_WRAPPERS.length; i++) {
      const STORIES_SLIDER_WRAPPER = STORIES_SLIDER_WRAPPERS[i]
      const SLIDER = new StorySlider(STORIES_SLIDER_WRAPPER, AUDIO)
      SLIDER.init()
    }
  }
}

class StorySlider {
  constructor (wrapper, AUDIO) {
    this.wrapper = wrapper
    this.audio = AUDIO
    this.slider = this.wrapper.querySelector('.swiper')

    this.init = () => {
      this.addSlider()
      this.addStoriesClick()
      this.addAudioClick()
    }
  }

  addSlider () {
    if (this.slider) {
      this.swiper = new Swiper(this.slider, {
        effect: 'creative',
        slidesPerView: 'auto',
        spaceBetween: 630,
        speed: 800,
        loop: false,
        threshold: 10,
        centeredSlides: false,
        slideToClickedSlide: true,
        creativeEffect: {
          prev: {
            translate: ['-100%', 0, 0],
            scale: .9
          },
          next: {
            translate: ['30.6%', 0, 0],
            scale: .9,
            shadow: true,
          },
          limitProgress: 5,
        },
        pagination: {
          el: this.wrapper.querySelector('.swiper-pagination'),
          type: 'progressbar',
        },
        on: {
          slideChange: () => {
            this.changeLoopItem(this.swiper.realIndex)
            this.changeExcerpt(this.swiper.realIndex)
          },
        }
      })

      this.setPaginationTextPosition()
    }
  }

  addStoriesClick () {
    this.storyItems = this.wrapper.querySelectorAll('.mtt-stories-slider__loop-item-info')

    if (this.storyItems.length) {
      for (let i = 0; i < this.storyItems.length; i++) {
        const ITEM = this.storyItems[i]

        ITEM.addEventListener('click', () => {
          const PARENT = ITEM.parentElement
          const DATA_INDEX = parseInt(PARENT.getAttribute('data-index'))
          this.changeLoopItem(DATA_INDEX)
        })
      }
    }
  }

  setPaginationTextPosition () {
    const PAGINATION_TEXTS = this.wrapper.querySelectorAll('.mtt-stories-slider__pagination-item')
    const SWIPER_COUNT = this.swiper.slides.length

    if (PAGINATION_TEXTS.length) {
      for (let i = 0; i < PAGINATION_TEXTS.length; i++) {
        const TEXT = PAGINATION_TEXTS[i]
        const INDEX = TEXT.getAttribute('data-index')

        TEXT.style.width = 100 / SWIPER_COUNT + '%'

        TEXT.addEventListener('click', () => {
          this.changeLoopItem(INDEX)
        })
      }
    }
  }

  changeLoopItem (slideIndex) {
    this.wrapper.querySelector('.mtt-stories-slider__loop-item.active').classList.remove('active')
    this.wrapper.querySelector('.mtt-stories-slider__loop-item[data-index="' + slideIndex + '"]').classList.add('active')

    this.wrapper.querySelector('.mtt-stories-slider__pagination-item.active').classList.remove('active')
    this.wrapper.querySelector('.mtt-stories-slider__pagination-item[data-index="' + slideIndex + '"]').classList.add('active')

    this.swiper.slideTo(slideIndex)
  }

  changeExcerpt (slideIndex) {
    const CORRECT_EXCERPT_WRAPPER = this.wrapper.querySelector('.swiper-slide[data-index="' + slideIndex + '"]')

    if (CORRECT_EXCERPT_WRAPPER) {

      if (CORRECT_EXCERPT_WRAPPER.querySelector('.mtt-story-card__excerpt-mobile')) {
        this.wrapper.querySelector('.mtt-stories-slider__excerpt').innerHTML = CORRECT_EXCERPT_WRAPPER.querySelector('.mtt-story-card__excerpt-mobile').innerHTML
      } else {
        this.wrapper.querySelector('.mtt-stories-slider__excerpt').innerHTML = ''
      }
    }
  }

  addAudioClick () {
    const AUDIO_ITEMS = this.wrapper.querySelectorAll('[data-file]')

    if (AUDIO_ITEMS.length) {
      for (let i = 0; i < AUDIO_ITEMS.length; i++) {
        const AUDIO_ITEM = AUDIO_ITEMS[i]

        AUDIO_ITEM.addEventListener('click', () => {
          if (this.audio.src !== AUDIO_ITEM.getAttribute('data-file')) {
            this.audio.src = AUDIO_ITEM.getAttribute('data-file')
          }
          this.toggleAudioPlay()
        })
      }
    }
  }

  toggleAudioPlay () {
    if (this.audio.duration > 0 && !this.audio.paused) {
      this.audio.pause()
    } else {
      this.audio.play()
    }
  }
}